var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq48(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.571484,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8078,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.3953,
    y1: 12.1824,
    x2: 49.6316,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.721462,
    y1: 49.8543,
    x2: 11.9578,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.1574,
    y1: 38.6199,
    x2: 49.3938,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.483616,
    y1: 0.944118,
    x2: 11.7199,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.476 27.62V26.878L21.572 20.018H22.734V26.766H24.232V27.62H22.734V30H21.768V27.62H16.476ZM21.81 21.096L17.61 26.766H21.81V21.096ZM27.4419 24.792C26.8633 24.6053 26.4199 24.3113 26.1119 23.91C25.8133 23.5087 25.6639 23.0233 25.6639 22.454C25.6639 21.95 25.7899 21.502 26.0419 21.11C26.3033 20.7087 26.6813 20.396 27.1759 20.172C27.6706 19.9387 28.2633 19.822 28.9539 19.822C29.6446 19.822 30.2373 19.9387 30.7319 20.172C31.2266 20.396 31.5999 20.7087 31.8519 21.11C32.1133 21.502 32.2439 21.95 32.2439 22.454C32.2439 23.014 32.0899 23.4993 31.7819 23.91C31.4833 24.3207 31.0446 24.6147 30.4659 24.792C31.1006 24.9507 31.5999 25.254 31.9639 25.702C32.3279 26.15 32.5099 26.696 32.5099 27.34C32.5099 27.9373 32.3606 28.46 32.0619 28.908C31.7726 29.3467 31.3573 29.6873 30.8159 29.93C30.2839 30.1727 29.6633 30.294 28.9539 30.294C28.2446 30.294 27.6193 30.1727 27.0779 29.93C26.5459 29.6873 26.1306 29.3467 25.8319 28.908C25.5426 28.46 25.3979 27.9373 25.3979 27.34C25.3979 26.696 25.5799 26.15 25.9439 25.702C26.3079 25.254 26.8073 24.9507 27.4419 24.792ZM31.2919 22.566C31.2919 21.95 31.0819 21.474 30.6619 21.138C30.2419 20.802 29.6726 20.634 28.9539 20.634C28.2353 20.634 27.6659 20.802 27.2459 21.138C26.8259 21.4647 26.6159 21.9407 26.6159 22.566C26.6159 23.1447 26.8306 23.6067 27.2599 23.952C27.6893 24.2973 28.2539 24.47 28.9539 24.47C29.6539 24.47 30.2186 24.2973 30.6479 23.952C31.0773 23.6067 31.2919 23.1447 31.2919 22.566ZM28.9539 25.226C28.1886 25.226 27.5633 25.3987 27.0779 25.744C26.5926 26.0893 26.3499 26.612 26.3499 27.312C26.3499 27.984 26.5833 28.5113 27.0499 28.894C27.5166 29.2767 28.1513 29.468 28.9539 29.468C29.7473 29.468 30.3773 29.2767 30.8439 28.894C31.3106 28.502 31.5439 27.9747 31.5439 27.312C31.5439 26.6213 31.3013 26.1033 30.8159 25.758C30.3399 25.4033 29.7193 25.226 28.9539 25.226Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq48);
export default __webpack_public_path__ + "static/media/fq48.d56eea0a68025a35e0e8e27b7e7c779b.svg";
export { ForwardRef as ReactComponent };